import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function WarningIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.2472 4.12874C8.93993 3.51539 8.0646 3.51525 7.75714 4.12847L4.24848 11.1265L3.80151 10.9024L4.24848 11.1265C3.97065 11.6806 4.37354 12.3333 4.99342 12.3333H12.0076C12.6273 12.3333 13.0302 11.6809 12.7527 11.1268L9.2472 4.12875L9.2472 4.12874ZM6.86321 3.68027C7.53963 2.33114 9.46535 2.33152 10.1413 3.68086L10.1413 3.68087L13.6468 10.6789C14.2574 11.8979 13.371 13.3333 12.0076 13.3333H4.99342C3.62967 13.3333 2.74331 11.8974 3.35454 10.6783L6.86321 3.68027ZM8.50004 5.99999C8.86823 5.99999 9.16671 6.29846 9.16671 6.66665V7.99999C9.16671 8.36818 8.86823 8.66665 8.50004 8.66665C8.13185 8.66665 7.83337 8.36818 7.83337 7.99999V6.66665C7.83337 6.29846 8.13185 5.99999 8.50004 5.99999ZM9.16671 10.6667C9.16671 11.0348 8.86823 11.3333 8.50004 11.3333C8.13185 11.3333 7.83337 11.0348 7.83337 10.6667C7.83337 10.2985 8.13185 9.99999 8.50004 9.99999C8.86823 9.99999 9.16671 10.2985 9.16671 10.6667Z"
        fill="currentColor"
      />
    </svg>
  );
};
